import { Stack } from '@mui/material'
import { observer } from 'mobx-react-lite'
import UserAccount from '../UserAccount'
import MobileLayoutWrapper from 'Components/Elements/UserAccountMenu/MobileLayoutWrapper'
import styled from '@emotion/styled'
import Breadcrumb from 'Components/Elements/UserAccountMenu/Breadcrumb'
import { storeElement } from 'GlobalStores/StoreElement'
import Profile from 'Components/Elements/Achievements/Profile'
import SuccessTracker from 'Components/Elements/Achievements/SuccessTracker'
import Centurion from 'Components/Elements/Centurion/Centurion'
import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'
import { storeElement as storeElementGlobal } from 'GlobalStores/Cores/Elements/StoreElement'

const AchievementsPage = observer(() => {
    useEffect(() => {
        runInAction(() => {
            storeElementGlobal.cardTitle.titleStep1 = <T>achievements</T>
            storeElementGlobal.settingCard.title = ''
            storeElementGlobal.settingCard.padding = ''
        })

        return () => {
            runInAction(() => {
                storeElementGlobal.cardTitle.titleStep1 = ''
                storeElementGlobal.settingCard.padding = ''
            })
        }
    }, [])
    return (
        <>
            {storeElement.IsMobile() ? (
                <WrapperMobileLayout>
                    <Profile display={'none'} />
                    <SuccessTracker />
                    <Centurion />
                </WrapperMobileLayout>
            ) : (
                <UserAccount backgroundColor={'transparent'}>
                    <Stack display={'grid'} gridTemplateColumns={'398px 398px'} gap={2}>
                        <Profile display={'none'} />
                        <Stack>
                            <SuccessTracker />
                        </Stack>
                        <Stack>
                            <Centurion />
                        </Stack>
                    </Stack>
                </UserAccount>
            )}
        </>
    )
})

export const WrapperMobileLayout = observer(props => {
    return (
        <MobileLayoutWrapper>
            <StackMobileLayout>
                <Stack width={'100%'}>
                    <Breadcrumb />
                    <Stack width={'100%'} gap="16px">
                        {props.children}
                    </Stack>
                </Stack>
            </StackMobileLayout>
        </MobileLayoutWrapper>
    )
})

const StackMobileLayout = styled(Stack)`
    align-items: center;
    background: #d1d9e2 !important;
    display: flex;
    width: 100%;

    .mobile-layout-box {
        box-sizing: border-box;
        width: 100%;
        padding: 0;
        background-color: #fff;
        box-shadow: 0px 1px 2px rgba(14, 35, 56, 0.2);
        border-radius: 12px;
    }

    @media screen and (min-width: 414px) {
        .mobile-layout-box {
            /* width: 384px; */
        }
    }
`
const DesktopLayout = styled('div')`
    box-sizing: border-box;
    width: 100%;
    padding: 32px;
    background-color: #fff;
    border-radius: 12px;
`

export default AchievementsPage
